import globalInitialState from "./global.initialstate";
import { SET_VISITED_LIST, SET_IP_LOCATION, SET_FOOTER_LOCATIONS, SET_SEARCH_HISTORY,SET_AVAILABILITY } from "./global.types";


const globalReducer = (state = globalInitialState, action) => {


    switch (action.type) {

        case SET_VISITED_LIST:
            return {
                ...state,
                visitedList: action.payload,
            }

        case SET_IP_LOCATION:
            return {
                ...state,
                locationDetail: action.payload,
                locationStoreTime: Date.now()
            }

        case SET_FOOTER_LOCATIONS:
            return {
                ...state,
                footerLocations: action.payload,
                footerLocationStoreTime: Date.now()
            }


        case SET_SEARCH_HISTORY:
            return {
                ...state,
                searchHistory: action.payload,
            }

        case SET_AVAILABILITY:
            return {
                ...state,
                availablity: action.payload,

            }

        default:
            return state;
    }
};

export default globalReducer;